import React, { memo, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { AngularWrapper } from '../angular-wrapper';
import { MatIcon } from '@angular/material/icon';
import { isEqual } from 'lodash-es';
import { DiscoverFilteringOption } from '@box-types';

type BadgeType = 'default' | 'destructive';

type BadgeOption = DiscoverFilteringOption;

type BadgeProps = {
  label: string;
  imageUrl?: string;
  type?: BadgeType;
  className?: string;
  options?: BadgeOption;
  onBadgeClick?: (options: BadgeOption) => void;
};

function BadgeComponent({ label, imageUrl, type = 'default', className, onBadgeClick, options }: BadgeProps) {
  const handleBadgeClick = useCallback(
    (options: BadgeOption) => {
      onBadgeClick?.(options);
    },
    [onBadgeClick]
  );

  return (
    <div className={classNames('badge-component', `badge-component--${type}`, className)}>
      {imageUrl && <img src={imageUrl} alt={label} className="badge-component-image" />}
      <span className="ods-typography-button-s">{label}</span>
      {onBadgeClick && (
        <button
          onClick={() => handleBadgeClick(options)}
          className="badge-component-button mdc-icon-button mat-mdc-icon-button mat-unthemed mat-mdc-button-base"
          aria-label="Close"
        >
          <AngularWrapper
            inputs={{ fontSet: 'material-icons-round' }}
            className="material-icons-round"
            component={MatIcon}
          >
            close
          </AngularWrapper>
        </button>
      )}
    </div>
  );
}

// secures from unecessary rerenders due to bad state management from the parent
const areEqual = (prevProps, nextProps) => {
  return isEqual(prevProps, nextProps);
};

export default memo(BadgeComponent, areEqual);
